import type { OfficerPerfRow } from '../api/types'

/** One officer's district-wide rollup for the Officers leaderboard. */
export interface OfficerRollup {
  officerId: string
  name: string
  /** Mandals the officer serves (first-seen order). */
  mandals: string[]
  assigned: number
  completed: number
  missed: number
  /** completed / assigned (V2 single source of truth) — null when nothing is assigned. */
  completionPct: number | null
}

/**
 * Aggregate the paginated officer×mandal report rows into one row per officer. Completion is derived
 * as `completed / assigned` from the SAME counts as completed/missed (decision D6), so the leaderboard
 * can never disagree with the per-officer numbers. Officers with nothing assigned report `null` (not 0%).
 */
export function officerRollup(rows: OfficerPerfRow[]): OfficerRollup[] {
  const byId = new Map<string, OfficerRollup>()
  for (const r of rows) {
    const o = byId.get(r.officerId) ?? { officerId: r.officerId, name: r.officerName, mandals: [], assigned: 0, completed: 0, missed: 0, completionPct: null }
    o.assigned += r.assigned
    o.completed += r.completed
    o.missed += r.missed
    if (!o.mandals.includes(r.mandal)) {
      o.mandals.push(r.mandal)
    }
    byId.set(r.officerId, o)
  }
  for (const o of byId.values()) {
    o.completionPct = o.assigned > 0 ? Math.round((o.completed / o.assigned) * 100) : null
  }
  return [...byId.values()]
}
